import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'falak.admin.token';

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch (_) { return null; }
};
const setToken = (t) => {
  try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch (_) { /* ignore */ }
};

const authConfig = () => {
  const t = getToken();
  return { withCredentials: true, headers: t ? { Authorization: `Bearer ${t}` } : {} };
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  if (typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export async function adminLogin(email, password) {
  const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
  setToken(data.access_token);
  return data;
}

export async function adminMe() {
  const { data } = await axios.get(`${API}/auth/me`, authConfig());
  return data;
}

export async function adminLogout() {
  try { await axios.post(`${API}/auth/logout`, {}, authConfig()); } catch (_) { /* ignore */ }
  setToken(null);
}

export async function fetchAnnouncement(offset) {
  const { data } = await axios.get(`${API}/admin/announcement`, { ...authConfig(), params: { offset } });
  return data;
}
